import { DateType } from 'ui/datePicker';

export type DateParams = {
  startDate: DateType;
  endDate: DateType;
};

export type TimeParams = {
  startTime?: string;
  endTime?: string;
  timeRangeHasData: boolean;
};

export enum TimePreset {
  PAST_30_DAYS = 'PAST_30_DAYS',
  PAST_60_DAYS = 'PAST_60_DAYS',
  PAST_90_DAYS = 'PAST_90_DAYS',
  CUSTOM_RANGE = 'CUSTOM_RANGE',
}

export type TimePresetContext = {
  menuLabel: string;
  filterLabel: string;
  format?: (timezone?: string) => DateParams;
};

export interface TimeFilterContextState {
  timeParams: TimeParams;
  updateTimeParams: (timeParams: TimeParams) => void;
}
